exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.encode-text[data-v-52271354] {\n  font-size: 16px;\n  font-weight: bold;\n}\n", "", {"version":3,"sources":["E:/office/burgeon/基板/burgeon-business-components/src/components/input/input.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,kBAAkB;CACnB","file":"input.vue","sourcesContent":["\n.encode-text[data-v-52271354] {\n  font-size: 16px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-52271354","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/input/input.vue
// module id = 389
// module chunks = 0